import React, { useState } from 'react';
import CustomTable from 'ui-components/CustomTable';
import { B400 } from 'ui-components/CustomButton';
import { Primary } from 'ui-components/Buttons';
import { Add, Mail, MailOutline, MailOutlined, MailOutlineRounded, PersonAddAlt, ThumbUp, PublishedWithChanges, CallReceived, PersonRemove, DeleteOutlineRounded, EditOutlined, UpdateOutlined, Upload, GetAppOutlined, Done, DoneRounded, Update, Description, DescriptionOutlined, Close, Flag, Edit, DeleteOutlined } from '@mui/icons-material';
import { ReactComponent as MoreOptionsIcon } from "assets/rounds_icons/more_solid_icon.svg";
import ModalComponent from 'ui-components/ModalComponent';
import { ReactComponent as FlagIcon } from '../../assets/nav_icons/flag-svgrepo-com.svg';
import InviteInvestorPopup from './popups/InviteInvestorPopup';
import { ReactComponent as RoundInvestmentIcon } from "assets/rounds_icons/round_investor_icon.svg"
import { Box, Button, capitalize, Card, Dialog, Grid, Menu, MenuItem, Paper, Skeleton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import BankDetailsPopup from './popups/BankDetailsPopup';
import CustomTabs from 'ui-components/CustomTabs';
import { makeStyles } from '@mui/styles';
import { TabContext } from '@mui/lab';
import AddInvestmentPopup from './popups/AddInvestmentPopup';
import AllocateAmountPopup from './popups/AllocateAmountPopup';
import AddSHADocumentsPopup from './popups/AddSHADocumentsPopup';
import { ReactComponent as RoundInvestorsIcon } from "assets/rounds_icons/round_investor_icon.svg"
import AllocateUnits from './popups/AllocateUnits';
import AddInvestorPopup from './popups/AddInvestorPopup';
import DeleteConfirmationDialog from 'ui-components/popups/ConfirmationPopup';
import { DeleteInvestorFromRoundInvestorListing, FetchRoundInvestorsData, MovetoSelectedStatus } from 'api';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import AsyncTableListing from 'ui-components/AsyncTableListing';
import TableListingSkeleton from 'ui-components/TableListingSkeleton';
import InvestorMovePopup from 'ui-components/popups/ConfirmationPopup';
import CapTableIcon from "ui-components/icons/CapTableIcon"
import NoData from 'ui-components/NoData';
import { hasPermission } from 'utilities/index';
import { useSelector } from 'react-redux';
import { DeleteInvestment, FetchInvestmentListing } from 'api/investors';
import Cookies from 'js-cookie';

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        "&": {
            padding: "3rem"
        }
        // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
    }
    //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
    //         display: 'none !important',
    //         transition: 'all 1s ease'
    //     },
    // }
}));

function generateEmail(name) {
    return `${name.toLowerCase().replace(" ", ".")}@example.com`;
}

const CardHeader = ({ title, data: CardHeader, action = () => { } }) => {
    return <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} p={"0.5rem 1rem"}>
        <Typography fontWeight={700} fontSize={"1.25rem"}>
            {title}
        </Typography>
    </Box>
}


const CapTable = ({ currency, round_id }) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const classes = useStyles();
    const [value, setValue] = React.useState("all");
    const startup_id = Cookies.get("X-ST-ID");
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    const [openInvitePopup, setOpenInvitePopup] = React.useState(false);
    const [openBankDetailsPopup, setOpenBankDetailsPopup] = React.useState(false);
    const [currentRow, setCurrentRow] = React.useState(null);

    const handleInvitePopupOpen = () => {
        setOpenInvitePopup(true);
    }

    const handleInvitePopupClose = () => {
        setOpenInvitePopup(false);
    }

    const handleInviteInvestor = () => {
        handleInvitePopupClose()
    }

    const handleBankDetailsPopupOpen = () => {
        setOpenBankDetailsPopup(true)
    }

    const handleBankDetailsPopupClose = () => {
        setOpenBankDetailsPopup(false)
    }

    const handleSubmitBankDetails = () => {
        handleBankDetailsPopupClose()
    }

    const [openAddInvestorModal, setOpenAddInvestorModal] = React.useState(false);

    const handleAddInvestorClose = (row) => {
        setCurrentRow(null)
        setOpenAddInvestorModal(false);
    }
    const handleAddInvestorSubmit = () => {
        setOpenAddInvestorModal(false)
        setCurrentRow(null)
    }

    const InvitedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 180, align: 'start', fixed: true },
        // { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        // { Header: 'Date', accessor: 'date', minWidth: 150, align: 'center' },
        // { Header: 'Status', accessor: 'all_status', minWidth: 100, align: 'center' },
        { Header: 'Source', accessor: 'source', minWidth: 150, align: 'center', status: true },
        { Header: 'Round Name', accessor: 'round_name', minWidth: 150, align: 'center' },
        { Header: 'Round Type', accessor: 'round_type', minWidth: 150, align: 'center' },
        { Header: 'Security Type', accessor: 'security_type', minWidth: 150, align: 'center' },
        { Header: 'Investment Amount', accessor: 'total_investment_amount_ref', minWidth: 200, align: 'center', tooltip: "formatted_interested_amount_date" },
        { Header: 'Shares Issued', accessor: 'shares_issued', minWidth: 150, align: 'center' },
        { Header: 'Share Class', accessor: 'share_class', minWidth: 150, align: 'center' },
        { Header: 'Price Per Share', accessor: 'formatted_price_per_share', minWidth: 200, align: 'center' },
        { Header: 'Equity (%)', accessor: 'equity_percentage', minWidth: 150, align: 'center' },
        // { Header: 'Date of Investment', accessor: 'date_of_investment', minWidth: 150, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // edit
    ];

    const InterestedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        { Header: 'Date', accessor: 'date', minWidth: 150, align: 'center' },
        { Header: 'Interested Amount', accessor: 'interested_amount_ref', minWidth: 200, align: 'center', tooltip: "formatted_interested_amount_date" },
        // { Header: 'Status', accessor: 'all_status', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to rejected 
    ];
    // { Header: 'Actions', accessor: 'actions', minWidth: 100 }, // move to interested and rejected "with comments" interested amount

    const RejectedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        { Header: 'Date', accessor: 'date', minWidth: 150, align: 'center' },
        // { Header: 'Status', accessor: 'all_status', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to interested
    ];


    const columns = React.useMemo(
        () =>
            //      [
            //     { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start' },
            //     { Header: 'Interested Amount', accessor: 'amountCommitted', minWidth: 100, align: 'center' },
            //     { Header: 'Allocated Amount', accessor: 'amountReceived', minWidth: 100, align: 'center' },
            //     { Header: 'Received Amount', accessor: 'callForMoney', minWidth: 100, align: 'center' },
            //     // { Header: 'Call for Money', accessor: 'callForMoney', minWidth: 100, align: 'center' },
            //     { Header: 'Price per Share', accessor: 'drawdown', minWidth: 100, align: 'center' },
            //     // { Header: 'Drawdown %', accessor: 'drawdown', minWidth: 150 },
            //     // { Header: 'Share %', accessor: 'share', minWidth: 150 },
            //     { Header: 'No. of Shares', accessor: 'units', minWidth: 100, align: 'center' },
            //     { Header: 'Status', accessor: 'status', minWidth: 100, align: 'center' },
            //     { Header: 'Actions', accessor: 'actions', minWidth: 100 },
            // ]
            value === 'all' ? InvitedColumns : value === 'rejected' ? RejectedColumns : InterestedColumns
        ,
        [value]
    );

    // const { id: round_id } = useParams();
    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(10);
    const [sort, setSort] = React.useState(-1);
    const [search, setSearch] = React.useState("");
    // const { data: transformedData, refetch: refetchListing, isLoading: isLoadingRoundInvestors } = FetchRoundInvestorsData({ id: round_id, value, page, limit, sort })
    // console.log(transformedData, "transformedDatatransformedData")
    const formatAmount = (amount, currency) => {
        if (!amount) return null;

        let formattedAmount = amount;
        let suffix = "";

        if (currency === "INR") {
            if (amount >= 10000000) {
                formattedAmount = (amount / 10000000).toFixed(1);
                suffix = " Cr";
            } else if (amount >= 100000) {
                formattedAmount = (amount / 100000).toFixed(1);
                suffix = " L";
            } else if (amount >= 1000) {
                formattedAmount = (amount / 1000).toFixed(1);
                suffix = "K";
            }
            return `₹${formattedAmount}${suffix}`;
        } else if (currency === "USD") {
            if (amount >= 1000000) {
                formattedAmount = (amount / 1000000).toFixed(1);
                suffix = "M";
            } else if (amount >= 1000) {
                formattedAmount = (amount / 1000).toFixed(1);
                suffix = "K";
            }
            return `$${formattedAmount}${suffix}`;
        }
        return amount;
    };

    const { data: investmentListingData, refetch: refetchListing, isLoading: isLoadingInvestmentListingData } = FetchInvestmentListing({ id: startup_id, limit, page, search, value, sort });

    // console.log(investmentListingData, isLoading)

    const transformedData = {
        data: [
            // Invited
            {
                name: 'John Doe',
                type: 'Received',
                date: '15-Feb-2024',
                status: 'all',
                image: 'https://randomuser.me/api/portraits/men/1.jpg',
                actions: 'Move to Interested / Rejected',
                source: 'Self',
                email: 'johndoe@example.com',
                round_name: 'Seed Round',
                round_type: 'Seed',
                security_type: 'Equity',
                investment_amount: formatAmount(5000000, "INR"), // ₹50 L
                shares_issued: "10,000",
                share_class: 'Common',
                price_per_share: '₹500',
                equity_percentage: '10%',
                date_of_investment: '10-Mar-2024'
            },
            {
                name: 'Jane Smith',
                type: 'Sent',
                date: '14-Feb-2024',
                status: 'all',
                image: 'https://randomuser.me/api/portraits/women/1.jpg',
                actions: 'Move to Interested / Rejected',
                source: 'Backrr',
                round_name: 'Pre-Seed 1',
                round_type: 'Pre-Seed',
                security_type: 'Equity',
                investment_amount: formatAmount(2500000, "USD"), // $2.5M
                shares_issued: "50,000",
                share_class: 'Preferred',
                price_per_share: '$50',
                equity_percentage: '15%',
                date_of_investment: '12-Mar-2024'
            },
            {
                name: 'Robert Brown',
                type: 'Received',
                date: '13-Feb-2024',
                status: 'all',
                image: 'https://randomuser.me/api/portraits/men/2.jpg',
                actions: 'Move to Interested / Rejected',
                source: 'Backrr',
                round_name: 'Pre-Seed 2',
                round_type: 'Pre-Seed',
                security_type: 'Convertible Note',
                investment_amount: formatAmount(100000, "INR"), // ₹1 L
                shares_issued: "2,000",
                share_class: 'Common',
                price_per_share: '₹50',
                equity_percentage: '5%',
                date_of_investment: '15-Mar-2024'
            },
            {
                name: 'Alice Green',
                type: 'Received',
                date: '12-Feb-2024',
                status: 'all',
                image: 'https://randomuser.me/api/portraits/women/2.jpg',
                actions: 'Move to Rejected',
                source: 'Self',
                email: 'alicegreen@example.com',
                round_name: 'Seed 1',
                round_type: 'Seed',
                security_type: 'Safe Note',
                investment_amount: formatAmount(750000, "USD"), // $750K
                shares_issued: "15,000",
                share_class: 'Preferred',
                price_per_share: '$30',
                equity_percentage: '8%',
                date_of_investment: '20-Mar-2024'
            },
            {
                name: 'Charlie Blue',
                type: 'Sent',
                date: '11-Feb-2024',
                status: 'all',
                image: 'https://randomuser.me/api/portraits/men/3.jpg',
                actions: 'Move to Rejected',
                source: 'Backrr',
                round_name: 'Pre-Seed 3',
                round_type: 'Pre-Seed',
                security_type: 'Equity',
                investment_amount: formatAmount(500000, "INR"), // ₹5 L
                shares_issued: "2,500",
                share_class: 'Common',
                price_per_share: '₹200',
                equity_percentage: '6%',
                date_of_investment: '25-Mar-2024'
            }

        ],
        count: 7,
        limit: 10,
    }
    // const isLoadingRoundInvestors = false;
    // const refetchListing = () => {
    //     console.log("refetchListing")
    // }
    const [popupOpen, setPopupOpen] = React.useState(false);

    const Actions = () => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const openMenu = Boolean(anchorEl);
        const handleClickMenu = (event, index) => {
            setAnchorEl(event.currentTarget);
            // setCurrentIndex(index)
            // console.log(event.currentTarget,"re")
        };
        const handleCloseMenu = (event) => {
            // console.log(event,"event")
            setAnchorEl(null);
            // setCurrentIndex(null);
        };
        return <Box display={"flex"} justifyContent={"center"} gap={1} height={"100%"}>
            {value === "efjkanerjvnsrjnvjkrnvjkn" ? canEdit && <B400 sx={{ height: 45, display: 'flex', marginLeft: 'auto', whiteSpace: 'nowrap', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: '0.5rem', marginLeft: '-0.25rem' } }} startIcon={<Add sx={{ width: 20, height: 20 }} />} onClick={() => handleInvitePopupOpen()}>Invite Investor</B400>
                : canEdit && <Primary sx={{
                    height: { xs: 40, sm: 45 },
                    display: 'flex',
                    marginLeft: 'auto',
                    whiteSpace: 'nowrap',
                    minWidth: 'auto',
                    padding: { xs: '0.5rem 0.75rem', sm: '12px 18px 12px 16px' },
                    fontSize: { xs: '0.8125rem', sm: '1rem' }
                }} onClick={() => {
                    sessionStorage.removeItem("investment_id")
                    navigate("/captable/add-investment");
                }} ><RoundInvestmentIcon style={{ width: 20, height: 15, marginRight: "0.5rem", flexShrink: 0, fill: !canEdit ? "rgba(0, 0, 0, 0.26)" : 'white' }} />Add Investment</Primary>}
            {/* <B400 startIcon={<RoundInvestmentIcon style={{ width: 20, height: 15, fill: 'white' }} />} onClick={() => {
                setPopupOpen(true);
            }} sx={{ display: 'flex', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }}>{isMediumScreen ? "" : "Add Investment"}</B400> */}
            {/* <Box> */}
            {/* {value === "interested" && transformedData?.data?.length > 0 &&
                <Button sx={{ minWidth: "1rem" }} onClick={(e) => handleClickMenu(e)}>
                    <MoreOptionsIcon style={{ color: theme.palette.customColors.indigo700 }} />
                </Button>
            } */}
            {/* {value === "all" && hasPermission("funding_rounds", "edit", userPermissions) &&
                <Button sx={{ minWidth: "1rem", marginBottom: '0.4rem' }} onClick={(e) => handleClickMenu(e)} disabled={!hasPermission("funding_rounds", "edit", userPermissions)}>
           
                    <MoreOptionsIcon style={{ color: theme.palette.customColors.indigo700 }} />
                </Button>
            } */}
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : 'false'}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette.customColors.whiteBG,
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 11,
                            width: 10,
                            height: 10,
                            bgcolor: theme.palette.customColors.g900,
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {value === "all" && canEdit && <MenuItem disableRipple onClick={() => setOpenAddInvestorModal(true)} sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                    <RoundInvestmentIcon style={{ width: 20, height: 15, fill: 'white', marginRight: '0.5rem' }} /> Add Investor
                </MenuItem>}
                {/* <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                    <Upload sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Import Investors
                </MenuItem> */}
                {/* {value === "all" && transformedData?.data?.length > 0 &&
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <GetAppOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Export Investors
                    </MenuItem>
                }
                {value === "interested" &&
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <GetAppOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Export Investors
                    </MenuItem>
                } */}
            </Menu>
            {/* </Box> */}
        </Box>
    }

    const {
        mutateAsync: deleteInvestmentAsync,
        isLoading: isDeletingInvestment,
        status: deleteInvestorStatus,
        error: deleteInvestorError,
        data: deleteInvestorResponse
    } = DeleteInvestment();

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [openMoveInvestorPopup, setOpenMoveInvestorPopup] = useState(false);

    const canEdit = hasPermission('captable', 'edit', userPermissions);
    const canDelete = hasPermission('captable', 'delete', userPermissions);

    const RowActions = ({ row }) => {

        const isSelected = currentRow?._id === row?.original?._id;
        const [anchorEl, setAnchorEl] = React.useState(null);
        const openRowMenu = Boolean(anchorEl);

        const handleOpenRowMenu = (event) => {
            setAnchorEl(event.currentTarget);
        }
        const handleCloseRowMenu = () => {
            setAnchorEl(null);
        }

        // Step 2 of the add/edit investment page is the documents step
        const goToInvestmentForm = (step) => {
            sessionStorage.setItem("investment_id", row?.original?._id);
            navigate(step ? `/captable/edit-investment?page=${step}` : "/captable/edit-investment");
        }
        // console.log(isSelected, currentRow?._id, row?.original?._id)
        // code for Delete Popup
        const handleOpenDeletePopup = (interested) => {
            setOpenDeletePopup(true);
            setCurrentRow(interested);
        }
        const handleCloseDeletePopup = () => {
            setOpenDeletePopup(false);
            setCurrentRow(null);
        }

        const handleDelete = async () => {
            // console.log(currentRow?._id, "investment_id");
            try {
                await deleteInvestmentAsync({ investment_id: currentRow?._id }).then((succ) => { refetchListing(); handleCloseDeletePopup(); });

            } catch (error) {
                console.error("Error deleting investment:", error);
            }
        };

        // code for Moving investors from all to interested

        const handleOpenMoveInvestorPopup = (interested) => {
            setOpenMoveInvestorPopup(true);
            setCurrentRow(interested);
        }
        const handleCloseMoveInvestorPopup = () => {
            setOpenMoveInvestorPopup(false);
            setCurrentRow(null);
        }

        const {
            mutateAsync: updateStatusAsync,
            isLoading: isMovingInvestor,
            status: updateStatusStatus,
            error: updateStatusError,
            data: updateStatusResponse
        } = MovetoSelectedStatus({ round_id });

        const handleMovetoSelected = async () => {
            try {
                await updateStatusAsync({ payload: { investor_id: currentRow?.investor_id } }).then((succ) => { refetchListing(); handleCloseMoveInvestorPopup(); });

            } catch (error) {
                console.error("Error deleting investor:", error);
            }
        };

        return <>
            {
                isSelected && <DeleteConfirmationDialog open={openDeletePopup} handleClose={handleCloseDeletePopup} handleSubmission={handleDelete} heading={"Confirm Delete"} ActionText={"Delete"} subheading={"Are you sure you want to delete this investment?"} isLoading={isDeletingInvestment} />
            }
            {
                isSelected && <InvestorMovePopup open={openMoveInvestorPopup} handleClose={handleCloseMoveInvestorPopup} handleSubmission={handleMovetoSelected} heading={"Confirm Selection"} ActionText={"Confirm"} subheading={"Are you sure you want to move to interested investors?"} isLoading={isMovingInvestor} />
            }
            <Box display={"flex"} gap={1}>
                {/* <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
            
                     <MailOutlineRounded sx={{ color: theme.palette.customColors.indigo700 }} />
                </Button> */}
                <Tooltip title={"More Options"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={handleOpenRowMenu}
                        aria-haspopup="true"
                        aria-expanded={openRowMenu ? 'true' : undefined}
                    >
                        <MoreOptionsIcon style={{ color: theme.palette.customColors.indigo700 }} />
                    </Button>
                </Tooltip>
                <Menu
                    anchorEl={anchorEl}
                    open={openRowMenu}
                    onClose={handleCloseRowMenu}
                    onClick={handleCloseRowMenu}
                    PaperProps={{
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1,
                            padding: "12px",
                            borderRadius: "8px",
                            "& > ul.MuiList-root": { padding: "0 !important" },
                            bgcolor: theme.palette.customColors.g400,
                            color: theme.palette.customColors.whiteBG,
                            '&::before': {
                                content: '""',
                                display: 'block',
                                position: 'absolute',
                                top: 0,
                                right: 11,
                                width: 10,
                                height: 10,
                                bgcolor: theme.palette.customColors.g900,
                                transform: 'translateY(-50%) rotate(45deg)',
                                zIndex: 0,
                            },
                        },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem disableRipple disabled={!canEdit} onClick={() => goToInvestmentForm()} sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <EditOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Edit Investment
                    </MenuItem>
                    <MenuItem disableRipple disabled={!canEdit} onClick={() => goToInvestmentForm(2)} sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <DescriptionOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Add Documents
                    </MenuItem>
                    <MenuItem disableRipple disabled={!canDelete} onClick={() => handleOpenDeletePopup(row?.original)} sx={{ padding: '0.625rem 1rem' }}>
                        <DeleteOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Delete Investment
                    </MenuItem>
                </Menu>

                {/* {value !== "all" &&
                    <>
                        <Tooltip title={"Kyc request, upload"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                               
                                <Update sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Documents"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                          
                                <DescriptionOutlined sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Call for money"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                              
                                <MailOutlined sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Fund Received"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                             
                                <CallReceived sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                    </>
                } */}

                {/* <Button sx={{ minWidth: "1rem" }} disabled={!hasPermission("funding_rounds", "edit", userPermissions)} onClick={() => { setOpenAddInvestorModal(true); setCurrentRow(row?.original) }} >
            
                    <EditOutlined sx={{ color: hasPermission("funding_rounds", "edit", userPermissions) ? theme.palette.customColors.indigo700 : 'inherit' }} />
                </Button> */}
                {/* {(row?.original?.status === "all" || row?.original?.status === "interested") && <Tooltip title={"Move to Rejected"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={() => handleOpenDeletePopup(row?.original)} disabled={!hasPermission("funding_rounds", "edit", userPermissions)}>
                        <Close sx={{ color: hasPermission("funding_rounds", "edit", userPermissions) ? theme.palette.customColors.indigo700 : 'inherit' }} />
                    </Button>
                </Tooltip>} */}
            </Box>
        </>
    }


    const handleTabChange = (event, newValue) => {
        // console.log("value", newValue)
        setValue(newValue);
    };

    // const handleSwitch = () => {
    //     switch (value) {
    //         case 'all':
    //             // <></>
    //             return <AllocateAmountPopup currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         case 'interested':
    //             return <AllocateAmountPopup currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         case 'all':
    //             return <AllocateUnits currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         default:
    //             return <></>
    //     }
    // }

    // const filterByStatus = value === "all" ? transformedData?.data : transformedData?.data?.filter(item => item.round_type === value) || []

    // console.log(filterByStatus, "filterByStatus")

    const filterByStatus = investmentListingData?.data?.map((item) => {
        // console.log(item, "item")
        return {
            ...item,
            total_investment_amount_ref: item?.formatted_total_investment_amount ? item?.formatted_total_investment_amount : "-",
            source: item?.pipeline?.backrr_investor ? "Backrr" : "Self",
            investor_name: item?.name,
            round_type: item?.round_type_info,
            security_type: item?.security_type_info,
            organization_name: item?.organization_name,
            name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? `${item?.first_name} ${item?.last_name}` : item?.organization_name : `${item?.first_name} ${item?.last_name}`,
            image: item?.profile_picture,
            share_class: capitalize(item?.share_class),
            equity_percentage: item?.percentage_of_equity ? item?.percentage_of_equity + "%" : null
        }
    });

    return (
        <>
            <ModalComponent open={openInvitePopup} onClose={handleInvitePopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <InviteInvestorPopup handleClose={handleInvitePopupClose} refetchListing={refetchListing} handleSubmit={handleInviteInvestor} />
            </ModalComponent>
            <ModalComponent open={openAddInvestorModal} onClose={handleAddInvestorClose} style={{ maxWidth: 640, width: "100%" }}>
                <AddInvestorPopup currency={currency} refetchListing={refetchListing} value={value} handleClose={handleAddInvestorClose} handleSubmit={handleAddInvestorSubmit} currentRow={currentRow} />
            </ModalComponent>
            {/* <Dialog open={openBankDetailsPopup} onClose={() => { }}>
                <BankDetailsPopup handleClose={handleBankDetailsPopupClose} handleSubmit={handleSubmitBankDetails} />
            </Dialog> */}
            {/* <ModalComponent
                style={{ maxWidth: 640, width: "100%" }}
                //  sx={{ "& > .MuiDialog-container > .MuiPaper-root": { marginInline: 0 } }}
                open={openBankDetailsPopup} onClose={() => { handleBankDetailsPopupClose() }}>
                <Paper sx={{ maxHeight: '100%' }}>{handleSwitch()}</Paper>
            </ModalComponent> */}
            <Dialog open={popupOpen} onClose={() => { setPopupOpen(false) }}>
                <AddInvestmentPopup currency={currency} handleClose={() => setPopupOpen(false)} handleSubmit={handleSubmitBankDetails} />
            </Dialog>
            {/* <ModalComponent open={openBankDetailsPopup} onClose={handleBankDetailsPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                
            </ModalComponent> */}
            <TabContext value={value}>
                <Grid container xs={12} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
                    {/* <Grid item xs={10} lg={10}> */}
                    <Grid item xs={12} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                        <Grid xs={12} container sx={{ bgcolor: 'white', borderRadius: '16px 16px 0 0', borderInline: `1px solid ${theme.palette.customColors.b50}`, borderBlockStart: `1px solid ${theme.palette.customColors.b50}` }}>
                            <Grid item xs={5} sm={8}>
                                <CustomTabs
                                    variant="submenu"
                                    titleStyle={{ fontSize: '1rem' }}
                                    tabStyle={{ padding: '0.5rem 1rem 0rem' }}
                                    sx={{ border: 'none' }}
                                    bgColor={"transparent"}
                                    data={
                                        [
                                            { value: "all", label: value === 'all' ? `All (${filterByStatus?.length ? filterByStatus?.length : 0})` : "All", count: 10, read: false, icon: PublishedWithChanges },
                                            // { value: "Pre-Seed", label: value === 'Pre-Seed' ? `Pre-Seed (${filterByStatus?.length ? filterByStatus?.length : 0})` : "Pre-Seed", count: 10, read: false, icon: FlagIcon, useStroke: true },
                                            // { value: "Seed", label: value === 'Seed' ? `Seed (${filterByStatus?.length ? filterByStatus?.length : 0})` : "Seed", count: 10, read: false, icon: FlagIcon, useStroke: true },
                                        ]
                                    } value={value} handleChange={handleTabChange}
                                    isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                            </Grid>
                            <Grid item xs={7} sm={4} pt={0.75} pr={1} display={"flex"} alignItems={"center"} justifyContent={"flex-end"}>
                                <Actions />
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* { */}
                    {/* <Grid item xs={12} md={12} pt={"0 !important"} marginInline={"auto"} maxWidth={"100%"}> */}

                    {isLoadingInvestmentListingData ?
                        // Shaped like the cap table it replaces - avatar + name/email in the
                        // first cell, a Source chip, then the investment columns - so nothing
                        // resizes when the rows land. Scrolls sideways on a narrow screen,
                        // exactly as the real table does with 11 columns.
                        <Box width={"100%"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                            <TableListingSkeleton
                                rows={limit > 6 ? 6 : limit}
                                leading="avatar"
                                showPagination
                                columns={[
                                    { width: 52, cellWidth: 110, subWidth: 170, minWidth: 240 },
                                    { width: 60, cellWidth: 44, cellHeight: 26, minWidth: 130 },
                                    { width: 92, cellWidth: 88, minWidth: 150 },
                                    { width: 84, cellWidth: 52, minWidth: 150 },
                                    { width: 100, cellWidth: 56, minWidth: 150 },
                                    { width: 120, cellWidth: 52, minWidth: 150 },
                                    { width: 96, cellWidth: 44, minWidth: 150 },
                                    { width: 88, cellWidth: 60, minWidth: 150 },
                                    { width: 108, cellWidth: 56, minWidth: 150 },
                                    { width: 76, cellWidth: 48, minWidth: 150 },
                                    { width: 60, cellWidth: 28, cellHeight: 28, cellRadius: 14, minWidth: 100, align: 'end', grow: false },
                                ]}
                                sx={{ borderRadius: '0 0 16px 16px' }}
                            />
                        </Box>
                        : <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                            <AsyncTableListing
                                columns={InvitedColumns}
                                // data={[]}
                                tabValue={value}
                                data={filterByStatus}
                                // title={"Investors"}
                                // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                                actions={Actions}
                                page={page}
                                setPage={setPage}
                                limit={transformedData?.limit}
                                setLimit={setLimit}
                                count={filterByStatus?.length}
                                RowActions={RowActions}
                                emptyState={
                                    <NoData
                                        placeHolderImage={CapTableIcon}
                                        title="Set up your cap table to track ownership"
                                        subTitle=""
                                        Actions={() => (
                                            canEdit ? (
                                                <Primary
                                                    startIcon={<Add sx={{ fontSize: '1.25rem' }} />}
                                                    onClick={() => {
                                                        sessionStorage.removeItem("investment_id");
                                                        navigate("/captable/add-investment");
                                                    }}
                                                >
                                                    Set Up Cap Table
                                                </Primary>
                                            ) : null
                                        )}
                                        sx={{ borderRadius: '0 0 16px 16px', border: `1px solid ${theme.palette.customColors.b50}`, background: 'white' }}
                                    />
                                }
                                sx={{ borderRadius: '0 0 16px 16px', border: `1px solid ${theme.palette.customColors.b50}`, maxHeight: "calc(100dvh - 15rem)", background: 'white' }}
                                noD
                                refetchListing={refetchListing}
                            />
                        </Box>
                    }

                    {/* </Grid>} */}
                    {/* <Grid item xs={2} lg={2}> */}

                </Grid>
            </TabContext>
        </>
    );
};

export default CapTable;

///NEw UI

// import React from 'react';
// import {
//     Avatar,
//     Box,
//     Card,
//     Grid,
//     IconButton,
//     InputBase,
//     LinearProgress,
//     MenuItem,
//     Select,
//     Tab,
//     Tabs,
//     Typography,
//     useMediaQuery,
// } from '@mui/material';
// import { useTheme } from '@emotion/react';
// import { Doughnut } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import {
//     FileUploadOutlined,
//     PersonAddAlt1Outlined,
//     Search,
//     FilterAltOutlined,
//     MoreVert,
// } from '@mui/icons-material';
// import { B400 } from 'ui-components/CustomButton';
// import { Primary, Secondary } from 'ui-components/Buttons';

// ChartJS.register(ArcElement, Tooltip, Legend);

// // ---------------------------------------------------------------------------
// // Palette used by the cap table donut charts + legend
// // ---------------------------------------------------------------------------
// const CHART_COLORS = {
//     common: '#12B76A', // Common Shares  – green
//     preferred: '#1570EF', // Preferred Shares – blue
//     outstanding: '#475467', // Outstanding      – dark gray
//     available: '#D0D5DD', // Available        – light gray
//     convertibles: '#15B79E', // Convertibles     – teal
// };

// const LEGEND = [
//     { label: 'Common Shares', color: CHART_COLORS.common },
//     { label: 'Preferred Shares', color: CHART_COLORS.preferred },
//     { label: 'Outstanding', color: CHART_COLORS.outstanding },
//     { label: 'Available', color: CHART_COLORS.available },
//     { label: 'Convertibles', color: CHART_COLORS.convertibles },
// ];

// // ---------------------------------------------------------------------------
// // Sample shareholder data (matches the reference design)
// // ---------------------------------------------------------------------------
// const SHAREHOLDERS = [
//     { name: 'Peak XV Partners', shareClass: 'Common Shares', authorized: '5,580,000', outstanding: '5,580,000', ownership: '62.35%', fullyDiluted: '5,580,000', ownershipFd: '62.35%', amountRaised: '$12,710,000' },
//     { name: 'Olivia Sheks', shareClass: 'Preferred Shares', authorized: '2,150,000', outstanding: '2,150,000', ownership: '24.02%', fullyDiluted: '2,150,000', ownershipFd: '24.02%', amountRaised: '$4,900,000' },
//     { name: 'Ben John', shareClass: 'Series A Preferred', authorized: '650,000', outstanding: '650,000', ownership: '7.26%', fullyDiluted: '650,000', ownershipFd: '7.26%', amountRaised: '$1,650,000' },
//     { name: 'Accel Partners', shareClass: 'Series Seed Preferred', authorized: '350,000', outstanding: '350,000', ownership: '3.91%', fullyDiluted: '350,000', ownershipFd: '3.91%', amountRaised: '$800,000' },
//     { name: 'Hellon Venture', shareClass: 'Convertible Note', authorized: '120,000', outstanding: '120,000', ownership: '1.34%', fullyDiluted: '120,000', ownershipFd: '1.34%', amountRaised: '$250,000' },
//     { name: 'Better Capital', shareClass: 'Warrants', authorized: '80,000', outstanding: '80,000', ownership: '0.89%', fullyDiluted: '80,000', ownershipFd: '0.89%', amountRaised: '$120,000' },
//     { name: 'Titan Capital', shareClass: 'Employee Options', authorized: '15,000', outstanding: '15,000', ownership: '0.17%', fullyDiluted: '15,000', ownershipFd: '0.17%', amountRaised: '$0' },
//     { name: 'Maria Jonas', shareClass: 'Advisor Options', authorized: '5,000', outstanding: '5,000', ownership: '0.06%', fullyDiluted: '5,000', ownershipFd: '0.06%', amountRaised: '$0' },
// ];

// const TOTAL_ROW = {
//     authorized: '8,950,000',
//     outstanding: '8,950,000',
//     ownership: '100.00%',
//     fullyDiluted: '8,950,000',
//     ownershipFd: '100.00%',
//     amountRaised: '$20,430,000',
// };

// const AVATAR_COLORS = ['#7F56D9', '#F79009', '#12B76A', '#1570EF', '#EE46BC', '#475467', '#F04438', '#06AED4'];

// // ---------------------------------------------------------------------------
// // Donut chart with a centered label
// // ---------------------------------------------------------------------------
// const DonutChart = ({ segments, centerLabel, size = 176, cutout = '72%' }) => {
//     const data = {
//         labels: segments.map((s) => s.label),
//         datasets: [
//             {
//                 data: segments.map((s) => s.value),
//                 backgroundColor: segments.map((s) => s.color),
//                 borderColor: '#ffffff',
//                 borderWidth: 2,
//                 spacing: 0,
//             },
//         ],
//     };

//     const options = {
//         cutout,
//         responsive: true,
//         maintainAspectRatio: true,
//         animation: false,
//         plugins: {
//             legend: { display: false },
//             tooltip: { enabled: true },
//         },
//     };

//     return (
//         <Box sx={{ position: 'relative', width: size, height: size }}>
//             <Doughnut data={data} options={options} />
//             <Box
//                 sx={{
//                     position: 'absolute',
//                     inset: 0,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     textAlign: 'center',
//                     padding: '0 22%',
//                     pointerEvents: 'none',
//                 }}
//             >
//                 <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, lineHeight: 1.25, color: '#475467' }}>
//                     {centerLabel}
//                 </Typography>
//             </Box>
//         </Box>
//     );
// };

// // ---------------------------------------------------------------------------
// // Cap Table
// // ---------------------------------------------------------------------------
// const CapTable = () => {
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//     const [tab, setTab] = React.useState('shareholders');
//     const [search, setSearch] = React.useState('');
//     const [rowsPerPage, setRowsPerPage] = React.useState(10);

//     const b50 = theme.palette.customColors.b50;
//     const indigo = theme.palette.customColors.indigo700;

//     const ownershipSegments = [
//         { label: 'Common Shares', value: 15, color: CHART_COLORS.common },
//         { label: 'Preferred Shares', value: 10, color: CHART_COLORS.preferred },
//         { label: 'Outstanding', value: 8, color: CHART_COLORS.outstanding },
//         { label: 'Available', value: 63, color: CHART_COLORS.available },
//         { label: 'Convertibles', value: 4, color: CHART_COLORS.convertibles },
//     ];

//     const amountSegments = [
//         { label: 'Preferred Shares', value: 82, color: CHART_COLORS.preferred },
//         { label: 'Convertibles', value: 18, color: CHART_COLORS.convertibles },
//     ];

//     const filteredRows = SHAREHOLDERS.filter((r) =>
//         r.name.toLowerCase().includes(search.trim().toLowerCase())
//     );

//     const cellSx = {
//         padding: '14px 16px',
//         fontSize: '0.8125rem',
//         color: '#475467',
//         whiteSpace: 'nowrap',
//         borderBottom: `1px solid ${theme.palette.customColors.gray200}`,
//         fontFamily: '"Lato", sans-serif',
//     };
//     const headCellSx = {
//         ...cellSx,
//         color: '#667085',
//         fontWeight: 600,
//         backgroundColor: '#F9F8FE',
//         borderBottom: `1px solid ${theme.palette.customColors.gray200}`,
//     };

//     const numericCols = [
//         { key: 'authorized', label: 'Authorized Shares' },
//         { key: 'outstanding', label: 'Outstanding Shares' },
//         { key: 'ownership', label: 'Ownership %' },
//         { key: 'fullyDiluted', label: 'Fully Diluted Shares' },
//         { key: 'ownershipFd', label: 'Ownership % (FD)' },
//         { key: 'amountRaised', label: 'Amount Raised' },
//     ];

//     return (
//         <Box sx={{ padding: { xs: '0rem 1rem', sm: '0rem 2rem' }, maxWidth: '100%' }}>
//             {/* ----------------------------------------------------------- */}
//             {/* Header row: title + profile progress + need help            */}
//             {/* ----------------------------------------------------------- */}
//             {/* <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 flexWrap="wrap"
//                 gap={2}
//                 mb={2}
//             >
//                 <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, color: '#101828', fontFamily: '"Lato", sans-serif' }}>
//                     Cap Table
//                 </Typography>
//                 <Box display="flex" alignItems="center" gap={2}>
//                     <Box display={{ xs: 'none', md: 'flex' }} alignItems="center" gap={1}>
//                         <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, color: '#344054' }}>
//                             Profile Progress: 90%
//                         </Typography>
//                         <LinearProgress
//                             variant="determinate"
//                             value={90}
//                             sx={{
//                                 width: 90,
//                                 height: 6,
//                                 borderRadius: 4,
//                                 backgroundColor: b50,
//                                 '& .MuiLinearProgress-bar': { backgroundColor: indigo, borderRadius: 4 },
//                             }}
//                         />
//                     </Box>
//                     <Secondary sx={{ height: 40, padding: '8px 16px', fontSize: '0.875rem' }}>
//                         Need Help?
//                     </Secondary>
//                 </Box>
//             </Box> */}

//             {/* ----------------------------------------------------------- */}
//             {/* Subtitle + Export / Add Investor                            */}
//             {/* ----------------------------------------------------------- */}
//             <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 flexWrap="wrap"
//                 gap={2}
//                 mb={2}
//             >
//                 <Typography sx={{ fontSize: '0.9375rem', color: '#667085', fontFamily: '"Lato", sans-serif' }}>
//                     Overview of your company's capitalization and ownership.
//                 </Typography>
//                 <Box display="flex" alignItems="center" gap={1.5}>
//                     <Secondary
//                         startIcon={<FileUploadOutlined sx={{ width: 18, height: 18 }} />}
//                         sx={{ height: 42, padding: '8px 16px', fontSize: '0.875rem' }}
//                     >
//                         Export
//                     </Secondary>
//                     <Primary
//                         startIcon={<PersonAddAlt1Outlined sx={{ width: 18, height: 18 }} />}
//                         sx={{ height: 42, padding: '8px 16px', fontSize: '0.875rem', background: indigo }}
//                     >
//                         Add Investor
//                     </Primary>
//                 </Box>
//             </Box>

//             {/* ----------------------------------------------------------- */}
//             {/* Summary card: fully diluted / amount raised + donuts        */}
//             {/* ----------------------------------------------------------- */}
//             <Card
//                 elevation={0}
//                 sx={{
//                     border: `1px solid ${b50}`,
//                     borderRadius: '16px',
//                     padding: { xs: '1.25rem', md: '1.5rem 2rem' },
//                     mb: 2.5,
//                 }}
//             >
//                 <Grid container alignItems="center" spacing={3}>
//                     <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '0.875rem', color: '#667085' }}>Fully diluted shares</Typography>
//                         <Typography sx={{ fontSize: '1.375rem', fontWeight: 700, color: '#101828', mb: 2.5 }}>
//                             61,357,230
//                         </Typography>
//                         <Typography sx={{ fontSize: '0.875rem', color: '#667085' }}>Amount raised</Typography>
//                         <Typography sx={{ fontSize: '1.375rem', fontWeight: 700, color: '#101828' }}>
//                             $20,372,872
//                         </Typography>
//                     </Grid>

//                     <Grid item xs={6} md={2.5} display="flex" justifyContent="center">
//                         <DonutChart segments={ownershipSegments} centerLabel="Ownership & fully diluted shares" />
//                     </Grid>

//                     <Grid item xs={6} md={2.5} display="flex" justifyContent="center">
//                         <DonutChart segments={amountSegments} centerLabel="Amount raised" />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                         <Box display="flex" flexDirection="column" gap={1.25} sx={{ pl: { md: 2 } }}>
//                             {LEGEND.map((item) => (
//                                 <Box key={item.label} display="flex" alignItems="center" gap={1.25}>
//                                     <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: item.color }} />
//                                     <Typography sx={{ fontSize: '0.875rem', color: '#344054' }}>{item.label}</Typography>
//                                 </Box>
//                             ))}
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Card>

//             {/* ----------------------------------------------------------- */}
//             {/* Tabs + search + filter                                      */}
//             {/* ----------------------------------------------------------- */}
//             <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 flexWrap="wrap"
//                 gap={2}
//                 sx={{ borderBottom: `1px solid ${theme.palette.customColors.gray200}`, mb: 0 }}
//             >
//                 <Tabs
//                     value={tab}
//                     onChange={(e, v) => setTab(v)}
//                     TabIndicatorProps={{ style: { backgroundColor: indigo, height: 2 } }}
//                     sx={{
//                         minHeight: 'auto',
//                         '& .MuiTab-root': {
//                             textTransform: 'none',
//                             fontSize: '0.9375rem',
//                             fontWeight: 600,
//                             color: '#667085',
//                             padding: '10px 4px',
//                             marginRight: '2rem',
//                             minHeight: 'auto',
//                             fontFamily: '"Lato", sans-serif',
//                         },
//                         '& .Mui-selected': { color: `${indigo} !important` },
//                     }}
//                 >
//                     <Tab value="shareholders" label={`Shareholders (${SHAREHOLDERS.length})`} />
//                     <Tab value="option_pool" label="Option Pool" />
//                 </Tabs>

//                 <Box display="flex" alignItems="center" gap={1} pb={1}>
//                     <Box
//                         display="flex"
//                         alignItems="center"
//                         sx={{
//                             border: `1px solid ${theme.palette.customColors.gray200}`,
//                             borderRadius: '8px',
//                             padding: '6px 12px',
//                             minWidth: { xs: 160, sm: 240 },
//                         }}
//                     >
//                         <Search sx={{ width: 18, height: 18, color: '#98A2B3', mr: 1 }} />
//                         <InputBase
//                             value={search}
//                             onChange={(e) => setSearch(e.target.value)}
//                             placeholder="Search investors..."
//                             sx={{ fontSize: '0.875rem', flex: 1, fontFamily: '"Lato", sans-serif' }}
//                         />
//                     </Box>
//                     <IconButton
//                         sx={{
//                             border: `1px solid ${theme.palette.customColors.gray200}`,
//                             borderRadius: '8px',
//                             width: 40,
//                             height: 40,
//                         }}
//                     >
//                         <FilterAltOutlined sx={{ width: 18, height: 18, color: '#667085' }} />
//                     </IconButton>
//                 </Box>
//             </Box>

//             {/* ----------------------------------------------------------- */}
//             {/* Shareholders table                                          */}
//             {/* ----------------------------------------------------------- */}
//             <Box
//                 sx={{
//                     border: `1px solid ${theme.palette.customColors.gray200}`,
//                     borderRadius: '12px',
//                     overflow: 'hidden',
//                     mt: 2,
//                 }}
//             >
//                 <Box sx={{ overflowX: 'auto' }}>
//                     <Box component="table" sx={{ width: '100%', minWidth: 900, borderCollapse: 'collapse' }}>
//                         <Box component="thead">
//                             <Box component="tr">
//                                 <Box component="th" sx={{ ...headCellSx, textAlign: 'left' }}>Investor</Box>
//                                 <Box component="th" sx={{ ...headCellSx, textAlign: 'left' }}>Share Class</Box>
//                                 {numericCols.map((c) => (
//                                     <Box component="th" key={c.key} sx={{ ...headCellSx, textAlign: 'left' }}>
//                                         {c.label}
//                                     </Box>
//                                 ))}
//                                 <Box component="th" sx={{ ...headCellSx, width: 48 }} />
//                             </Box>
//                         </Box>
//                         <Box component="tbody">
//                             {filteredRows.map((row, i) => (
//                                 <Box component="tr" key={row.name}>
//                                     <Box component="td" sx={{ ...cellSx }}>
//                                         <Box display="flex" alignItems="center" gap={1.25}>
//                                             <Avatar
//                                                 sx={{
//                                                     width: 28,
//                                                     height: 28,
//                                                     fontSize: '0.75rem',
//                                                     bgcolor: AVATAR_COLORS[i % AVATAR_COLORS.length],
//                                                 }}
//                                             >
//                                                 {row.name.charAt(0)}
//                                             </Avatar>
//                                             <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: '#101828' }}>
//                                                 {row.name}
//                                             </Typography>
//                                         </Box>
//                                     </Box>
//                                     <Box component="td" sx={cellSx}>{row.shareClass}</Box>
//                                     {numericCols.map((c) => (
//                                         <Box component="td" key={c.key} sx={cellSx}>{row[c.key]}</Box>
//                                     ))}
//                                     <Box component="td" sx={{ ...cellSx, textAlign: 'center' }}>
//                                         <IconButton size="small">
//                                             <MoreVert sx={{ width: 18, height: 18, color: '#98A2B3' }} />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                             {/* Totals row */}
//                             <Box component="tr">
//                                 <Box component="td" sx={{ ...cellSx, fontWeight: 700, color: '#101828', borderBottom: 'none' }}>
//                                     Total
//                                 </Box>
//                                 <Box component="td" sx={{ ...cellSx, borderBottom: 'none' }} />
//                                 {numericCols.map((c) => (
//                                     <Box component="td" key={c.key} sx={{ ...cellSx, fontWeight: 700, color: '#101828', borderBottom: 'none' }}>
//                                         {TOTAL_ROW[c.key]}
//                                     </Box>
//                                 ))}
//                                 <Box component="td" sx={{ ...cellSx, borderBottom: 'none', textAlign: 'center' }}>
//                                     <IconButton size="small">
//                                         <MoreVert sx={{ width: 18, height: 18, color: '#98A2B3' }} />
//                                     </IconButton>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     </Box>
//                 </Box>
//             </Box>

//             {/* ----------------------------------------------------------- */}
//             {/* Pagination footer                                           */}
//             {/* ----------------------------------------------------------- */}
//             <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 flexWrap="wrap"
//                 gap={2}
//                 mt={2}
//             >
//                 <Typography sx={{ fontSize: '0.8125rem', color: '#667085' }}>
//                     Showing 1 to {filteredRows.length} of {SHAREHOLDERS.length} investors
//                 </Typography>
//                 <Box display="flex" alignItems="center" gap={1}>
//                     <Typography sx={{ fontSize: '0.8125rem', color: '#667085' }}>Rows per page:</Typography>
//                     <Select
//                         value={rowsPerPage}
//                         onChange={(e) => setRowsPerPage(e.target.value)}
//                         size="small"
//                         sx={{
//                             fontSize: '0.8125rem',
//                             '& .MuiSelect-select': { padding: '4px 28px 4px 10px' },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.customColors.gray200 },
//                         }}
//                     >
//                         {[10, 25, 50].map((n) => (
//                             <MenuItem key={n} value={n}>{n}</MenuItem>
//                         ))}
//                     </Select>
//                 </Box>
//             </Box>
//         </Box>
//     );
// };

// export default CapTable;
